import MenuList from '@mui/material/MenuList'
import MenuItem from '@mui/material/MenuItem'
import ListItemText from '@mui/material/ListItemText'
import ListItemIcon from '@mui/material/ListItemIcon'
import ContentPaste from '@mui/icons-material/ContentPaste'
import Badge from '@mui/material/Badge'
import { Box } from '@mui/material'
import { General } from './general'
import { Items } from './items'
import { Freight } from './freight'
import { useOrderStore } from 'modules/orders/store'
import { MdArticle } from 'react-icons/md'
import { FaTruck } from 'react-icons/fa'
import {
  BsCartFill,
  BsFillCartCheckFill,
  BsFillCreditCardFill
} from 'react-icons/bs'
import { Payment } from './payment'
import { Summary } from './summary'
import { useFormContext } from 'react-hook-form'
import { LEFT_SIDE_WIDTH } from './Form'

export const menuItems = [
  {
    id: 'general',
    label: 'Geral',
    icon: <MdArticle className="icon" />,
    Component: General,
    fields: [
      'unity',
      'seller',
      'indicator',
      'customer',
      'orderType',
      'crossSale',
      'purchaseOrder',
      'representantOrderNumber',
      'opportunity',
      'saleChannel',
      'paymentResponsible',
      'observation',
      'cdPedidoReserva'
    ]
  },
  {
    id: 'payment',
    label: 'Pagamento',
    icon: <BsFillCreditCardFill className="icon" />,
    Component: Payment,
    fields: ['paymentTerm']
  },
  {
    id: 'items',
    label: 'Itens',
    icon: <BsCartFill className="icon" />,
    Component: Items,
    fields: ['orderItems']
  },
  {
    id: 'freight',
    label: 'Frete',
    icon: <FaTruck className="icon" />,
    Component: Freight,
    fields: [
      'freightType',
      'freightPrice',
      'deliveryDate',
      'requestedDate',
      'expeditionObs',
      'hasDirtRoadQuiz',
      'dirtRoadQuizQuest1',
      'dirtRoadQuizQuest2',
      'dirtRoadQuizQuest3',
      'dirtRoadQuizQuest4',
      'deliveryAddressCompany'
    ]
  },

  {
    id: 'summary',
    label: 'Resumo',
    icon: <BsFillCartCheckFill className="icon" />,
    Component: Summary,
    fields: [
      'totalDiscount',
      'totalExpenses',
      'commissionPercent',
      'installments',
      'entryPercent',
      'entryValue',
      'proposalValidity'
    ]
  }
]

export default function Menu() {
  const setCurrentStep = useOrderStore.useSetCurrentStep()
  const currentStep = useOrderStore.useCurrentStep()
  const { formState, trigger } = useFormContext()
  const { errors } = formState

  const isError = (index: number) => {
    return Object.keys(errors)
      .map((error) => menuItems[index].fields.includes(error))
      .some((item) => item)
  }

  const handleMenuItemClick = async (id: string) => {
    return
    const isValid = await trigger()
    if (isValid) setCurrentStep(id)
  }

  return (
    <Box sx={{ width: LEFT_SIDE_WIDTH }}>
      <MenuList>
        {menuItems.map((item, index) => {
          const Icon = item.icon || <ContentPaste fontSize="small" />
          return (
            <MenuItem
              key={item.id}
              style={{ cursor: 'default' }}
              selected={currentStep === menuItems[index].id}
              onClick={() => handleMenuItemClick(item.id)}
              disabled={
                !!Object.keys(errors).length &&
                currentStep !== menuItems[index].id
              }
            >
              <Badge
                variant="dot"
                color="error"
                invisible={!isError(index)}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'left'
                }}
              >
                <ListItemIcon>{Icon}</ListItemIcon>
              </Badge>
              <ListItemText>{item.label}</ListItemText>
            </MenuItem>
          )
        })}
      </MenuList>
    </Box>
  )
}
